import { render, staticRenderFns } from "./edit-thumbnail-modal.vue?vue&type=template&id=f8443e3c&scoped=true&"
import script from "./edit-thumbnail-modal.vue?vue&type=script&lang=ts&"
export * from "./edit-thumbnail-modal.vue?vue&type=script&lang=ts&"
import style0 from "./edit-thumbnail-modal.vue?vue&type=style&index=0&id=f8443e3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8443e3c",
  null
  
)

export default component.exports